"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useId, useRef, useState, } from "react";
import "./global.css";
export var DEFAULT_SCROLL_PROVIDER_STATE = {
    position: {
        x: 0,
        y: 0,
    },
    isLocked: false,
    locks: [],
    lock: function () { },
    unlock: function () { },
    applyLock: function () { },
};
var ScrollProviderContext = createContext(DEFAULT_SCROLL_PROVIDER_STATE);
export function ScrollProvider(_a) {
    var children = _a.children;
    var _b = __read(useState(DEFAULT_SCROLL_PROVIDER_STATE), 2), state = _b[0], setState = _b[1];
    var stateRef = useRef(state);
    var positionRef = useRef({ top: 0 });
    var lock = useCallback(function (id) {
        if (stateRef.current.locks.indexOf(id) > -1)
            return;
        var position = lockWindow() || stateRef.current.position;
        var next = (stateRef.current = __assign(__assign({}, stateRef.current), { position: position, isLocked: true, locks: __spreadArray(__spreadArray([], __read(stateRef.current.locks), false), [id], false) }));
        setState(next);
    }, [state]);
    var unlock = useCallback(function (id) {
        var index = stateRef.current.locks.indexOf(id);
        if (index < 0)
            return;
        var locks = __spreadArray([], __read(stateRef.current.locks), false);
        locks.splice(index, 1);
        var isLocked = !!locks.length;
        var next = (stateRef.current = __assign(__assign({}, stateRef.current), { position: {
                x: 0,
                y: 0,
            }, locks: locks, isLocked: isLocked }));
        setState(next);
        if (!isLocked) {
            unlockWindow();
        }
    }, [state]);
    var applyLock = useCallback(function (scrollY) {
        setState(__assign(__assign({}, stateRef.current), { isLocked: true, position: applyWindowLock(scrollY) }));
    }, []);
    return (_jsx(ScrollProviderContext.Provider, { value: __assign(__assign({}, state), { lock: lock, unlock: unlock, applyLock: applyLock }), children: children }));
}
export function useScrollLock(isLockedProp) {
    var _a = useContext(ScrollProviderContext), lock = _a.lock, unlock = _a.unlock, applyLock = _a.applyLock, locks = _a.locks, rest = __rest(_a, ["lock", "unlock", "applyLock", "locks"]);
    var id = useId();
    var isLocked = locks.indexOf(id) > -1;
    var lockScroll = useCallback(function () {
        lock(id);
    }, [id, lock]);
    var unlockScroll = useCallback(function () {
        unlock(id);
    }, [id, unlock]);
    useEffect(function () {
        if (isLockedProp && !isLocked) {
            lock(id);
        }
        else if (!isLockedProp) {
            unlock(id);
        }
    }, [id, isLockedProp]);
    useEffect(function () {
        return function () {
            if (isLocked) {
                unlock(id);
            }
        };
    }, [id]);
    return __assign({ lockScroll: lockScroll, unlockScroll: unlockScroll, applyLock: applyLock }, rest);
}
var LOCKS = new Set();
var isWindowLocked = false;
var windowScrollY = 0;
export function checkIsWindowLocked() {
    return isWindowLocked;
}
function lockWindow() {
    if (isWindowLocked)
        return;
    return applyWindowLock();
}
function applyWindowLock(scrollY, scrollX) {
    scrollY = scrollX ? scrollX : window.scrollX;
    scrollY = scrollY ? scrollY : window.scrollY;
    var scrollbarWidth = getScrollbarWidth();
    document.body.classList.add("travel-scroll-locked");
    document.body.style.top = "-".concat(scrollY, "px");
    document.body.style.right = "0";
    document.body.style.left = "0";
    document.body.style.paddingRight = "".concat(scrollbarWidth, "px");
    windowScrollY = scrollY;
    isWindowLocked = true;
    return {
        x: scrollX || 0,
        y: scrollY || 0,
    };
}
function unlockWindow() {
    if (!isWindowLocked)
        return;
    document.body.classList.remove("travel-scroll-locked");
    document.body.style.top =
        document.body.style.right =
            document.body.style.left =
                "auto";
    document.body.style.paddingRight = "";
    isWindowLocked = false;
    window.scrollTo(0, windowScrollY);
}
function getScrollbarWidth() {
    return window.innerWidth - document.body.offsetWidth;
}
